import React, { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { EnrollDialog } from "@/pages/Presenca";
import { FileText, Loader2, ScanFace } from "lucide-react";

const GESTAO = ["SUPERADMIN", "DIRECAO", "COORDENACAO"];

export const StudentActions = ({ student, onDone }) => {
  const { user } = useAuth();
  const [enroll, setEnroll] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!GESTAO.includes(user?.role)) return null;
  const declaration = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/students/${student.id}/enrollment-declaration/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `declaracao_matricula_${student.registration || student.id}.pdf`; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch (e) {
      const msg = e.response?.data instanceof Blob ? JSON.parse(await e.response.data.text()).detail : e.response?.data?.detail;
      toast.error(formatApiError(msg));
    } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setEnroll(true)} data-testid="student-enroll-face-btn">
        <ScanFace className="mr-1.5 h-4 w-4" />Cadastrar biometria
      </Button>
      <Button variant="outline" size="sm" onClick={declaration} disabled={busy} data-testid="student-declaration-btn">
        {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <FileText className="mr-1.5 h-4 w-4" />}Declaração de Matrícula e Frequência
      </Button>
      {enroll && <EnrollDialog open={enroll} setOpen={setEnroll} student={student} onDone={onDone} />}
    </>
  );
};
